function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", {
  type: "text/css"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M278 200l468 0 0 394 54 0L800 162.006c0-8.838-7.166-16.006-16.007-16.006L240.007 146c-8.841 0-16.007 7.166-16.007 16.006L224 594l54 0L278 200z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M416 384m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M608 384m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M609 506.5c0 0-19-50.5-96.5-50.5S416 506.5 416 506.5s43.5-17.5 96.5-17.5S609 506.5 609 506.5z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M983.991 624 41.009 624C32.167 624 25 631.163 25 640l0 223c0 8.847 7.167 16 16.009 16l942.982 0c8.841 0 16.009-7.163 16.009-16L1000 640C1000 631.153 992.832 624 983.991 624zM613 776 413 776l0-48 200 0L613 776z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M194 420 28 594 194 594Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M830 420 830 594 996 594Z"
});

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    t: 1587369869007,
    className: "icon",
    viewBox: "0 0 1024 1024",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.bb4398e7.svg";
export { ForwardRef as ReactComponent };